import {BASE_URL} from "../../config/network";
import {resolveWhiteLabelSubsidiaryId} from "../../config/subsidiaryId";

const searchExternalRentVehicleAPI = async ({subsidiaryId, vehicleExternalId}) => {
    const requestSubsidiaryId = resolveWhiteLabelSubsidiaryId(subsidiaryId);
    const URL = `${BASE_URL}/public/new-way/search?subsidiary_id=${encodeURIComponent(requestSubsidiaryId)}&vehicle_external_id=${encodeURIComponent(vehicleExternalId)}`
    const METHOD = "GET"
    const HEADERS = {
        Accept: "application/json",
        "Content-Type": "application/json"
    }

    const response = await fetch(URL, {
        method: METHOD,
        headers: HEADERS
    })

    if (!response.ok) {
        const error = new Error(`HTTP error: ${response.status}`)
        error.status = response.status
        throw error
    }

    return await response.json()
}

export {searchExternalRentVehicleAPI}
